import React, { useEffect, useState } from "react";
import Autocomplete from '@mui/material/Autocomplete';
import { CircularProgress, TextField } from "@mui/material";
import axios from "axios";

const InlineSearchComponent = (props: any) => {
    const [options, setOptions] = useState<any[]>([]);
    const [optionValue, setOptionValue] = useState<any>({});
    const [loading, setLoading] = useState(false);
    let timer: NodeJS.Timeout;

    const setApiOptions = async () => {
        let modelAnonima: any = props.model;
        if ((modelAnonima[props.modelField] ?? '') != '') {
            await loadAutoComplete('', modelAnonima[props.modelField]);
        }

        loadComponent();
    }

    useEffect(() => {
        if (optionValue != null && optionValue[props.valueField]==props.model[props.modelField]) {
            return;
        }

        loadModel();
    }, [optionValue, props.model]);
    
    function loadModel() {
        if (props.urlApi != null) {
            (async () => {
                await setApiOptions();
            })();
        }
        else {
            setOptions(props.options);
            loadComponent();
        }
    }

    function loadComponent() {
        if (props.model == null) {
            if (JSON.stringify(props.optionValueSelected) == JSON.stringify(optionValue)) {
                return;
            }

            setOptionValue(props.optionValueSelected);
            return;
        }

        let modelAnonima: any = props.model;
        let opt = options?.find(x => x[props.valueField] == modelAnonima[props.modelField]) || {};
        if (JSON.stringify(opt) == JSON.stringify(optionValue)) {
            return;
        }

        setOptionValue(opt);
    }

    async function loadAutoComplete(text = '', id = 0) {
        if (props.urlApi == null) {
            return;
        }

        setLoading(true);

        id = id ?? 0;
        let reponse = await axios.get(`${props.urlApi}?criterio=${text}&id=${id}`);
        setOptions(reponse.data);

        if (id > 0) {
            setOptionValue(reponse.data[0]);
        }
        
        setLoading(false);
    }

    function setModelEvent(newOptionValue: any) {
        setOptionValue(newOptionValue);
        if (JSON.stringify(props.optionValue) == JSON.stringify(newOptionValue)) {
            return;
        }

        let modelAnonima: any = props.model;
        if (newOptionValue == null) {
            modelAnonima[props.modelField] = '';
            return;
        }

        if (props.model == null) {
            props.setValueEventCallBack(newOptionValue);
            return;
        }

        modelAnonima[props.modelField] = newOptionValue == null ? '' : newOptionValue[props.valueField];
        if (props.modelFieldName!=null)
        {
            modelAnonima[props.modelFieldName] = newOptionValue == null ? '' : newOptionValue[props.textField];
        }
    }

    async function onTextChangeTimer(e: any) {
        clearTimeout(timer);
        timer = setTimeout(
            function () {
                onTextChange(e);
            }, 1000);
    }

    async function onTextChange(e: any) {
        clearTimeout(timer);
        if (props.urlApi == null) {
            return;
        }

        let value = e.target.value;
        if (value.length == 0) {
            await loadAutoComplete();
        }
        else if (value.length < 3) {
            return;
        }

        await loadAutoComplete(value);
    }

    return (
        <div className={props.divClassName}>
            <Autocomplete
                fullWidth
                options={options}
                getOptionLabel={(optionValue) => optionValue[props.textField] ?? ''}
                value={optionValue}
                onChange={(event, opt: any) => setModelEvent(opt)}
                style={{ marginRight: 10 }}
                renderInput={(params) =>
                    <TextField {...params}
                        autoFocus={props.autoFocus}
                        label={props.label}
                        required={props.required}
                        onChange={async (e: any) => onTextChangeTimer(e)}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            ),
                        }}
                    />}
            />
        </div>
    )
}

export default InlineSearchComponent;